<template>
  <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择售后单"
      class="customer-edit"
      width="80%"
      top="5vh">
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="replacementBills/getAllCsList">
      <template slot="adSearch">
        <vm-search label="登记日期">
          <div class="block">
            <el-date-picker
                v-model="filter.beginCreateTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="date"
                style="width: 190px"
                placeholder="选择开始日期"/>
          </div>
        </vm-search>
        <vm-search label="至">
          <div class="block">
            <el-date-picker
                v-model="filter.endCreateTime"
                value-format="yyyy-MM-dd 23:59:59"
                type="date"
                style="width: 190px"
                placeholder="选择结束日期"/>
          </div>
        </vm-search>
        <vm-search label="单号">
          <el-input v-model.trim="filter.billNo" clearable/>
        </vm-search>
        <vm-search label="出厂编号">
          <el-input v-model.trim="filter.salesOrderNo" clearable/>
        </vm-search>
        <vm-search label="客户名称">
          <el-input v-model.trim="filter.customerName" clearable/>
        </vm-search>
        <vm-search label="登记人">
          <el-input v-model.trim="filter.creatorName" clearable/>
        </vm-search>
        <vm-search label="现场联系人">
          <el-input v-model.trim="filter.contact" clearable/>
        </vm-search>
        <vm-search label="现场联系方式">
          <el-input v-model.trim="filter.mobile" clearable/>
        </vm-search>
        <vm-search label="客户单号">
          <el-input v-model.trim="filter.customerBillNo" clearable/>
        </vm-search>
        <vm-search label="现场名称">
          <el-input v-model.trim="filter.siteName" clearable/>
        </vm-search>
        <vm-search label="物料号">
          <el-input v-model.trim="filter.materialNo" clearable/>
        </vm-search>
        <vm-search label="物料名称">
          <el-input v-model.trim="filter.materialDesc" clearable/>
        </vm-search>
        <vm-search label="发运人">
          <el-input v-model.trim="filter.deliveryPerson" clearable/>
        </vm-search>
        <vm-search label="收件人">
          <el-input v-model.trim="filter.consignee" clearable/>
        </vm-search>
        <vm-search label="流程状态">
          <el-select v-model.trim="filter.flowStatus" clearable placeholder="请选择流程状态">
            <el-option label="草稿" :value="10"/>
            <el-option label="待售后审核" :value="20"/>
            <el-option label="待售后复审" :value="30"/>
            <el-option label="待发货" :value="40"/>
            <el-option label="已完成" :value="50"/>
          </el-select>
        </vm-search>
        <vm-search label="发运类型">
          <el-select v-model.trim="filter.shipmentType" clearable placeholder="请选择发运类型">
            <el-option label="电机整机" :value="1"/>
            <el-option label="电机板卡" :value="2"/>
            <el-option label="电机整机/板卡" :value="3"/>
            <el-option label="电气产品" :value="4"/>
            <el-option label="外购件" :value="5"/>
            <el-option label="自制品" :value="6"/>
            <el-option label="维修件" :value="7"/>
          </el-select>
        </vm-search>
      </template>
      <el-table-column
          fixed="left"
          prop="billNo"
          width="140"
          align="center"
          label="售后单号"/>
      <el-table-column prop="submitTime" width="180" align="center" label="提交时间"/>
      <el-table-column
          prop="salesOrderNo"
          width="120"
          align="center"
          label="出厂编号"/>
      <el-table-column prop="customerBillNo" align="center" label="客户单号"/>
      <el-table-column prop="customerName" width="200" align="center" label="客户名称"/>
      <el-table-column prop="deliveryAddress" width="280" align="center" label="服务地点"/>
      <el-table-column prop="nodeDesc" width="140" align="center" label="当前节点">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 100">已完成</span>
          <span v-else>{{scope.row.nodeDesc}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="120px">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="onSelect(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "@/util/constant";


  export default {
    name:"ReplaceBillSelect",
    components: {VmTable,VmSearch},
    data() {
      return {
        constant,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        idList: "",
        filter: {
          userName: "",
          userType: "",
          employeeName: "",
          mobile: "",
          roleName: "",
          accountSetName: "",
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      onSelect(row) {
        this.$emit("select", row);
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
